import api from '../api'

export const postApplication = (params) => api.post('/admin/functionalities', params)

export const putApplication = (params) => api.put(`/admin/functionalities/${ params.id }`, params)

export const deleteApplication = (params) => api.delete(`/admin/functionalities/${ params.id }`)
